import { render } from "./columnProductInfo.vue?vue&type=template&id=56fe4cd3&scoped=true&ts=true"
import script from "./columnProductInfo.vue?vue&type=script&lang=ts"
export * from "./columnProductInfo.vue?vue&type=script&lang=ts"

import "./columnProductInfo.vue?vue&type=style&index=0&id=56fe4cd3&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56fe4cd3"]])

export default __exports__